import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export function useCapacitorMap(itemId: string) {
  return useQuery({
    queryKey: ['capacitorMap', itemId],
    queryFn: () => apiClient.getCapacitorMap(itemId),
    enabled: !!itemId,
    retry: false,
  });
}

export function useCreateCapacitorMap() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, data }: { itemId: string; data: any }) =>
      apiClient.createCapacitorMap(itemId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['capacitorMap', variables.itemId] });
    },
  });
}

export function useUpdateCapacitorMap() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, data }: { itemId: string; data: any }) =>
      apiClient.updateCapacitorMap(itemId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['capacitorMap', variables.itemId] });
    },
  });
}

export function useUpdateCapStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, designator, data }: { itemId: string; designator: string; data: any }) =>
      apiClient.updateCapStatus(itemId, designator, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['capacitorMap', variables.itemId] });
    },
  });
}
